<template>
    <div class="container-fluid" v-if="school && department && program">
        <div class="justify-content-between">
            <div>
                <h2>{{school.name}}/{{department.name}}/{{program.name}}</h2>
                <h3>Сурагч мэдээлэл нэмэх</h3>
            </div>
            <div >
                    <div >
                    <p>
                    
                        Түмэнцогт;Анужин;D1013021928;УЗ00272702;эмэгтэй
                    </p>
                    <div class="form-group">
                        <textarea rows="10" v-model.trim="teachersText" class="form-control" placeholder="Сурагч нарын мэдээлэл"/>
                    </div>
                
                    <button type="button" class="btn btn-danger" @click="addTeachers">
                        Сурагч нэмэх
                    </button>
                    <hr>
                    </div>
                <hr>
              
            </div>
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Хадгалах сурагчдын жагсаалт</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="tmpTeachers!=null && tmpTeachers.length>0">
                    <button class="btn btn-sm btn-success" @click="_saveAll">Бүгдийг хадгалах</button>
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Нэр</th>
                        <th>Овог</th>
                        <th>код</th>
                        <th>Регистр</th>
                        <th>Хүйс</th>

                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in tmpTeachers" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{teacher.name}}</td>
                            <td>{{teacher.lastname}}</td>
                            <td>{{teacher.code}}</td>
                            <td>{{teacher.register}}</td>
                            <td>{{teacher.gender}}</td>

                            <td>
                                <button class="btn btn-danger" @click="deleteTeacher(teacher, index)">хасах</button>
                                <button class="btn btn-warning" @click="_save(teacher, index, true)">хадгалах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>
            </div>
        </div>

        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               teachersText:null,
               tmpTeachers:[],
               school:null,
               department:null,
               program:null,
               loading: false

            }
        },
        props:{
            schoolId:{
                required:true
            },
            departmentId:{
                required:true
            },
            programId:{
                required:true
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getData(){
                fb.db.collection("schools").doc(this.schoolId).get().then(schoolData=>{
                    if(schoolData.exists){
                        let school=schoolData.data();
                        school.id=schoolData.id;
                        school.ref=schoolData.ref;
                        this.school=school;

                        schoolData.ref.collection("departments").doc(this.departmentId).get().then(depDoc=>{
                            if(depDoc.exists){
                                let dep= depDoc.data();
                                dep.id=depDoc.id;
                                dep.ref=depDoc.ref;
                                this.department=dep;

                                depDoc.ref.collection("programs").doc(this.programId).get().then(proDoc=>{
                                    if(proDoc.exists){
                                        let pro= proDoc.data();
                                        pro.id=proDoc.id;
                                        pro.ref=proDoc.ref;
                                        this.program=pro;
                                        
                                    }
                                });

                            }
                        });
                    }
                });

                
            },
            addTeachers(){
                if(this.teachersText!=null && this.teachersText!=''){
                    //TODO
                    var arrayOfLines = this.teachersText.match(/[^\r\n]+/g);
                    this.tmpTeachers=[];
                    arrayOfLines.forEach(value=>{
                        var lineArray=value.split(";");
                        // var lineArray=value.split("\t");

                        if(lineArray!=null  && lineArray[2]!=null && lineArray[2]!='' && lineArray[3]!=null && lineArray[3]!=''){
                            var genderString=lineArray[4];
                            var gender=null;
                            if(genderString){
                                genderString=genderString.toLowerCase();
                                if(genderString=="эрэгтэй")
                                    gender=0;
                                else if(genderString=="эмэгтэй")
                                    gender=1;
                                else if(genderString=="эр")
                                    gender=0;
                                else if(genderString=="эм")
                                    gender=1;
                            }
                            var studentDtail={
                                'name':lineArray[1].trim(),
                                'lastname': lineArray[0].trim(),
                                'code':lineArray[2].toLowerCase().trim(),
                                'register': lineArray[3].toLowerCase().trim(),
                                'created': fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                                'createdAt': new Date(),
                                'verified':false,
                                'gender': gender,
                                'school': fb.db.doc("schools/"+this.schoolId),
                                'department': fb.db.doc("schools/"+this.schoolId+'/departments/'+this.departmentId),
                                'program': fb.db.doc("schools/"+this.schoolId+'/departments/'+this.departmentId+'/programs/'+this.programId),
                                
                            };
                            this.tmpTeachers.push(studentDtail);
                                       
                        }
                    });
                    this.teachersText=''
                    }
            },
            deleteTeacher(teacher, index){
                if(teacher){
                    this.tmpTeachers.splice(index, 1);
                }
            },
            async _save(data, index, remove) {
       
                if(data!=null && data!=undefined){

                    var batch = fb.db.batch();      
                    this.loading=true;
                    var ts=await fb.db.collection("schools/"+this.schoolId+"/students").where("code", "==", data.code).limit(1).get();
                    if(ts.empty){
                        var tmpQuestion = Object.assign({}, data);
                
                        var questionRef=fb.db.doc("schools/"+this.schoolId).collection("students").doc();
                        batch.set(questionRef, tmpQuestion);
                        batch.update(
                            fb.db.collection("schools").doc(this.schoolId),
                            {numberOfStudents: fb.firestore.FieldValue.increment(1)}
                        )
                    
                        await batch.commit();
                    }
                    else
                        alert(data.code+" кодтой сурагч бүртгэгдсэн байна.");
                 
                    
                    this.loading=false;
                }
                if(remove!=null && remove==true)
                    this.tmpTeachers.splice(index,1);

            },
            async _saveAll() {
                
                if(this.tmpTeachers!=null && this.tmpTeachers.length>0){
                    var r = confirm("Бүгдийг хадгалах уу. Та хадгалагдаж дуустал вэбээс гаралгүй хүлээнэ үү");
                    if (r == true) {
                        var i=0;
                        for(const value of this.tmpTeachers){
                            await this._save(value, i, false);

                        }
                        this.tmpTeachers=[];
                        alert("Амжилттай хадгаллаа");
                         this.$router.back();
                    } 
                }

            },

        },
        created() {
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).format('MM/DD/YYYY HH:mm');
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
